import instance from "@/services/api";

export const shellEstimatesAPI = {
  async getShellEstimates(params) {
    return await instance()
      .get("/project_list/floor_params/read_smeta/", { params })
      .then((res) => res?.data);
  },
  async getRoomPurposeOptions() {
    return await instance()
      .get(`/project_list/common/room_purpose/`)
      .then((res) => res?.data);
  },
};
